export interface File {
  id: string;
  name: string;
  url?: string;
  mime: string;
}
